<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-cash"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Pickup Report {{ sitedetails.idnum }} Starting: {{ sitedetails.scheduledetails.startdate }} Schedule: {{ sitedetails.scheduledetails.schedule }}
              </div>
              <div class="display-2 font-weight-light">
                Last Pickup {{ lastpickup }} Capacity: {{ sitedetails.noteCapacity }}
              </div>
            </template>
            <v-row>
              <v-spacer />

              <download-csv
                :name="citfilename()"
                :data="projected_pickups"
              >
                <v-btn color="info">
                  <v-icon
                    color="white"
                    left
                  >
                    mdi-arrow-down
                  </v-icon>CSV
                </v-btn>
              </download-csv>
            </v-row>
            <v-divider class="mt-3" />
            <v-data-table
              :headers="headers"
              :items="projected_pickups"
              :search="search"
              class="elevation-1"
              :expanded.sync="expanded"
              :single-expand="singleExpand"

              expand-icon="mdi-chevron-down"
              item-key="rangeend"
              show-expand
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-col>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    />
                  </v-col>
                </v-toolbar>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                {{ format_amt(item.sum) }}
              </template>
              <template v-slot:no-data>
                <div class="display-2 font-weight-light">
                  Sorry, no messages to display for Smart Safe ID {{ id }}
                </div>
                <br>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  class="white"
                >
                  <v-row>
                    <v-col
                      lg="12"
                      md="12"
                    >
                      <v-row>
                        <v-col
                          lg="12"
                          md="12"
                        >
                          <v-data-table
                            :headers="pickupheader"
                            :items="item.pickups"
                            class="elevation-1"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </td>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format } from 'date-fns-tz'

  var numeral = require('numeral')

  export default {
    name: 'Deposits',
    props: ['id'],

    data () {
      return {
        expanded: [],
        singleExpand: true,
        calculating: true,
        countdown: '',
        search: '',
        sitedetails: '',
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#3bd6c6'],
              shadeIntensity: 1,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Cash in',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return numeral(value).format('$0,0.00')
              }
            }
          },
          xaxis: {
            categories: ['test'],
            labels: {
              formatter: function (value) {
                return moment(value).format('YYYY-MM-DD: HH:mm:ss')
              }
            }
          }
        },
        series: [{
          name: 'Deposits ',
          data: []
        }],
        headers: [
          { text: 'Time Period', value: 'unitoftime', align: 'center' },
          { text: 'Count', value: 'count', align: 'center' },
          { text: 'end', value: 'rangeend', align: 'center' },
          { text: 'start', value: 'rangestart', align: 'center' },
          { text: 'expected', value: 'expected', align: 'center' },
          { text: 'delta', value: 'delta', align: 'center' },
        ],
        pickupheader: [
          { text: 'Date', value: 'date', align: 'center' },
          { text: 'Note Count', value: 'count', align: 'center' },
          { text: 'FOB ID', value: 'fobID', align: 'center' },
          { text: 'Cash Total', value: 'grandTotal', align: 'center' },
        ],
        valid: true,
        paythingssafe: true,
        scheduledetails: {
          startdate: '',
          schedule: '',
        },
        graphsums: [],
        graphdays: [],
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        activeBtn: 1,
        grow: true,
        cashinperunit: '',
        loading: false
      }
    },

    computed: {
      lastpickup () {
        let cit_events = []
        let last_cit = 'No Data'
        cit_events = this.$store.getters.getsitePickups
        if (cit_events) {
          let events = cit_events.reverse()
          if (events.length > 0) {
            let event = cit_events.find(event => event.grandTotal > 0)
            last_cit = moment(event.TS).format('YYYY-MM-DD') + ' for ' + numeral(event.grandTotal).format('$0,00.00') + ', ' + moment(event.TS).fromNow('HH:mm:ss') + ' ago.'
          }
        }

        return last_cit
      },
      projected_pickups () {
        let PERIOD = 0
        let startdate = ''
        let schedule = ''
        let expectedPickups = []
        let details = ''
        let frequency = 0
        let cit_events = []
        cit_events = this.$store.getters.getsitePickups
        console.log('schedule detail ', this.$store.getters.getPickupSchedule)
        if (this.$store.getters.getPickupSchedule) {
          Object.assign(this.sitedetails, { scheduledetails: this.$store.getters.getPickupSchedule })
          schedule = this.$store.getters.getPickupSchedule.schedule
        } else {
          Object.assign(this.sitedetails, { scheduledetails: '' })
        }
        if (schedule.toLowerCase() === 'daily' || schedule.toLowerCase() === 'weekly' || schedule.toLowerCase() === 'biweekly' || schedule.toLowerCase() === 'monthly') {
          let frequency = 0
          if (schedule.toLowerCase() === 'daily') {
            // check each day
          }
          if (schedule.toLowerCase() === 'weekly') {
            // check if a pickup was present each week for the past 12 weeks
            for (let i = 0; i < 6; i++) {
              let startOfWeek = moment().subtract(i + 1, 'week').startOf('isoweek')
              let endOfWeek = moment().subtract(i + 1, 'week').endOf('isoweek')
              console.log(startOfWeek.format('YYYY-MM-DD'), endOfWeek.format('YYYY-MM-DD'))
              let qualifiyingpickups = []
              cit_events.forEach(event => {
                let time = moment(event.TS)
                if (time.isBetween(startOfWeek, endOfWeek)) {
                  if (event.grandTotal > 0) {
                    let count = 0
                    if (event.values) {
                      count = event.values.reduce((a, b) => a + (parseFloat(b['count']) || 0), 0)
                      console.log('NOTES ', event.values)
                    }
                    Object.assign(event, { date: moment(event.TS).format('YYYY-MM-DD HH:mm:ss') })
                    Object.assign(event, { count: count })
                    qualifiyingpickups.push(event)
                  }
                }
              })
              expectedPickups.push({
                unitoftime: 'week of year ' + moment(startOfWeek).format('ww'),
                count: qualifiyingpickups.length,
                delta: 0,
                expected: 1,
                pickups: qualifiyingpickups,
                rangeend: endOfWeek.format('YYYY-MM-DD'),
                rangestart: startOfWeek.format('YYYY-MM-DD'),
                period: 'week',
                frequency: 'weekly'
              })
            }
          }
          if (schedule.toLowerCase() === 'biweekly') {
            // check if a pickup was present within each 2 week period of last 3 months
            // is start week even or odd
            let details = this.$store.getters.getPickupSchedule
            let even = false
            let odd = false
            if (details.startdate) {
              console.log('#### week ', moment(details.startdate).isoWeek())
              if (moment(details.startdate).isoWeek() % 2 === 0) {
                console.log('is even ')
                even = true
                odd = false
              } else {
                console.log('is odd ')
                odd = true
                even = false
              }
            }
            for (let i = 0; i < 8; i++) {
              // is start week even or odd
              // get current week number
              let currentweeknum = moment().isoWeek()
              let startmom = moment()
              console.log('current week num ', currentweeknum)
              if (currentweeknum % 2 === 0) {
                // we are in an odd week
                // if our period of bi weekly is also even, do nothing
                // if odd then adjust a week out
                if (odd) {
                  startmom = moment().subtract(1, 'week')
                  let qualifiyingpickups = []
                  cit_events.forEach(event => {
                    let time = moment(event.TS)
                    if (time.isBetween(moment().startOf('isoweek'), moment().endOf('isoweek'))) {
                      if (event.grandTotal > 0) {
                        Object.assign(event, { date: moment(event.TS).format('YYYY-MM-DD HH:mm:ss') })
                        qualifiyingpickups.push(event)
                      }
                    }
                  })
                  // work ok later
                  expectedPickups.push({
                    unitoftime: 'week of year ' + moment().format('ww'),
                    count: qualifiyingpickups.length,
                    delta: 0,
                    expected: 1,
                    pickups: qualifiyingpickups,
                    rangeend: moment().endOf('isoweek').format('YYYY-MM-DD'),
                    rangestart: moment().startOf('isoweek').format('YYYY-MM-DD'),
                    period: 'week',
                    frequency: 'weekly'
                  })
                }
              }
              i = i + 1
              let endOfWeek = moment().subtract(i, 'week').endOf('isoweek')
              let startOfWeek = moment().subtract(i + 1, 'week').startOf('isoweek')
              console.log(startOfWeek.format('YYYY-MM-DD'), endOfWeek.format('YYYY-MM-DD'))
              let qualifiyingpickups = []
              if (cit_events) {
                cit_events.forEach(event => {
                  let time = moment(event.TS)
                  if (time.isBetween(startOfWeek, endOfWeek)) {
                    if (event.grandTotal > 0) {
                      Object.assign(event, { date: moment(event.TS).format('YYYY-MM-DD HH:mm:ss') })
                      qualifiyingpickups.push(event)
                    }
                  }
                })
              }

              expectedPickups.push({
                unitoftime: '2 week of year ' + moment(startOfWeek).format('ww'),
                count: qualifiyingpickups.length,
                delta: 0,
                expected: 1,
                pickups: qualifiyingpickups,
                rangeend: endOfWeek.format('YYYY-MM-DD'),
                rangestart: startOfWeek.format('YYYY-MM-DD'),
                period: 'week',
                frequency: 'weekly'
              })
            }
          }
          if (schedule.toLowerCase() === 'monthly') {
            console.log('MONTHLY')
            // check if a pickup was present in the past 3 months
            let startOfMonth = moment().startOf('month')
            let endOfMonth = moment().endOf('month')
            let startOflastMonth = moment().subtract(1, 'month').startOf('month')
            let endOflastMonth = moment().subtract(1, 'month').endOf('month')
            let startOffinalMonth = moment().subtract(2, 'month').startOf('month')
            let endOffinalMonth = moment().subtract(2, 'month').endOf('month')
            console.log(startOfMonth.format('YYYY-MM-DD'), endOfMonth.format('YYYY-MM-DD'))
            //        { text: 'Time Period', value: 'unitoftime', align: 'center' },
            // { text: 'Count', value: 'count', align: 'center' },
            // { text: 'end', value: 'rangeend', align: 'center' },
            // { text: 'start', value: 'rangestart', align: 'center' },
            // { text: 'period', value: 'period', align: 'center' },
            // { text: 'frequency', value: 'frequency', align: 'center' },
            let qualifiyingpickups = []
            cit_events.forEach(event => {
              let time = moment(event.TS)
              if (time.isBetween(startOfMonth, endOfMonth)) {
                if (event.grandTotal > 0) {
                  Object.assign(event, { date: moment(event.TS).format('YYYY-MM-DD HH:mm:ss') })
                  qualifiyingpickups.push(event)
                }
              }
            })
            expectedPickups.push({
              unitoftime: moment().format('YYYY-MMM'),
              count: qualifiyingpickups.length,
              delta: qualifiyingpickups.length - 1,
              expected: 1,
              pickups: qualifiyingpickups,
              rangeend: endOfMonth.format('YYYY-MM-DD'),
              rangestart: startOfMonth.format('YYYY-MM-DD'),
              period: 'month',
              frequency: 'monthly'
            })
            qualifiyingpickups = []
            cit_events.forEach(event => {
              let time = moment(event.TS)
              if (time.isBetween(startOflastMonth, endOflastMonth)) {
                if (event.grandTotal > 0) {
                  Object.assign(event, { date: moment(event.TS).format('YYYY-MM-DD HH:mm:ss') })
                  qualifiyingpickups.push(event)
                }
              }
            })
            expectedPickups.push({
              unitoftime: moment().subtract(1, 'months').format('YYYY-MMM'),
              count: qualifiyingpickups.length,
              delta: qualifiyingpickups.length - 1,
              expected: 1,
              pickups: qualifiyingpickups,
              rangeend: endOflastMonth.format('YYYY-MM-DD'),
              rangestart: startOflastMonth.format('YYYY-MM-DD'),
              period: 'month',
              frequency: 'monthly'
            })
            qualifiyingpickups = []
            cit_events.forEach(event => {
              let time = moment(event.TS)
              if (time.isBetween(startOffinalMonth, endOffinalMonth)) {
                if (event.grandTotal > 0) {
                  Object.assign(event, { date: moment(event.TS).format('YYYY-MM-DD HH:mm:ss') })
                  qualifiyingpickups.push(event)
                }
              }
            })
            expectedPickups.push({
              unitoftime: moment().subtract(2, 'months').format('YYYY-MMM'),
              count: qualifiyingpickups.length,
              delta: qualifiyingpickups.length - 1,
              expected: 1,
              pickups: qualifiyingpickups,
              rangeend: endOffinalMonth.format('YYYY-MM-DD'),
              rangestart: startOffinalMonth.format('YYYY-MM-DD'),
              period: 'month',
              frequency: 'monthly'
            })
          }
          // just get a years worth
        }

        return expectedPickups
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.graphsums = []
      this.graphdays = ''
      this.$log.debug('ID PASSED ', this.$route.params.id)
      this.id = this.$route.params.id
      this.$log.debug('###### site is ', this.id, ' safes ', this.$store.getters.loadedSites)
      this.sitedetails = this.$store.getters.loadedSites.find(location => this.id === location.idnum)

      this.initsitedetails(this.$route.params.id)
    },
    methods: {
      initsitedetails (machineid) {
        console.log('passed, ', machineid)
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
              this.createdtime = moment(this.sitedetails.Created_date).format('YYYY-MM-DD')
              Object.assign(this.sitedetails, { safeid: machineid })
              this.$store.dispatch('loadsitePickups', machineid)
              this.$store.dispatch('loadsiteschedule', this.sitedetails.sitekey)
            }
          }
        }
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_reconcile' + '_' + this.id + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      citfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_cit' + '_' + this.id + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      format_time (ts) {
        return moment(ts).format('YY-MM-DD HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
    }
  }
</script>
